import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Mail, MailInfosViaExtraStateRouter } from 'src/app/shared/models/mails/mail';
import { SuperListModel } from 'src/app/shared/models/superCompos/super-list-model';
import * as async from 'async';
import { forkJoin, interval, of, Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import * as _ from 'underscore';
import { Title } from '@angular/platform-browser';
import { DataService } from 'src/app/shared/services/data.service';
import { ToastrService } from 'ngx-toastr';
import { ParamsService } from 'src/app/shared/services/params.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { CourrierScheduler } from 'src/app/shared/models/iCourrier/courrierScheduler';
import { TranslateService } from '@devinforius/i-essentials';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { WorkflowsService } from 'src/app/shared/services/workflows.service';
import { BacSearch } from 'src/app/shared/models/workflows/bac-search';
import { Cols, TableColumnsSortableWithSortableLabel } from 'src/app/shared/models/cols';
import { catchError, map } from 'rxjs/operators';
import { MailsService } from 'src/app/shared/services/mails.service';
import { DocumentStatusDto } from 'src/app/shared/interfaces/documents/document-status-dto.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MeRightMailGlobal } from 'src/app/shared/models/iCourrier/me/right-mail-global';
import { PersonalParams } from 'src/app/shared/models/iCourrier/me/personal-params';
import { GlobalStatus } from 'src/app/shared/models/iCourrier/status-management/global-status';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { Box } from 'src/app/shared/models/superCompos/box';
import { GlobalSpecificStatutesService } from 'src/app/shared/services/global-specific-statutes.service';
import { MeService } from 'src/app/shared/services/me.service';
import { MailMeSearchDto, MailMeSearchPaginationDTO } from 'src/app/shared/interfaces';
import { GlobalStatusDTO } from 'src/app/shared/interfaces/global/global-status.interface';
import { MailMeCountDTO } from 'src/app/shared/models/mails/mail-me-count';
import { environment } from 'src/environments/environment';
import { IButtonMenuItem } from '@devinforius/i-essentials/lib/models/i-button-menuitem';
import { MailsMeSearchParams } from 'src/app/shared/models';
import { setServiceDescription } from 'src/app/utils/set-service-description.utils';

@Component({
  selector: 'app-home-courrier',
  templateUrl: './home-courrier.component.html',
  styleUrls: ['./home-courrier.component.scss'],
})
export class HomeCourrierComponent implements OnInit {
  public mails: Mail[] = [];
  public mailsUnreaded: Mail[] = [];
  public item: SuperListModel;
  public list: SuperListModel[] = [];
  public isLoading: boolean;
  public isMenuReady = true;
  public boxes3: Box[][] = [];
  public boxes: Box[][] = [];
  public boxes2: Box[][] = [];

  public mode = 'TDB';

  // Filter by consultation date
  public countsSeq2: MailMeCountDTO;
  public countsSeq3: MailMeCountDTO;
  public displayKanban = false;
  public items: MailMeSearchPaginationDTO;
  public columns: GlobalStatus[] = [];
  public temp1: { name: string; count: number }[] = [];
  public temp2: { name: string; count: number }[] = [];
  public temp3: { name: string; count: number; title?: string; icon?: string }[] = [];
  subscription: Subscription;
  public itemObject = null;
  public columnsTable: Cols[] = [];
  public contacts: Contact[] = [];
  public mailsByFolder: Mail[] = [];

  // scan for new mail TO DO
  public isScanMode = false;

  // paramsForFilesSearch
  public searchFilesParams: { classeurId?: number; chemiseId?: number };
  public rightMailGlobal: MeRightMailGlobal;
  public schedulerStatusList: {
    label: string;
    value: number;
    color: string;
    textColor: string;
    statut: DocumentStatusDto;
    ordre: number;
    globalStatutId: number;
    globalStatutName?: string;
  }[] = [];
  public courrierScheduler: CourrierScheduler[] = [];

  public favorites: PersonalParams[] = [];
  public savedSearch: {
    id: number;
    name: string;
    menu: string;
    title: string;
    displayOrder: number;
    hideFromPersonalDashboard: string;
    click: () => void;
  }[] = [];
  public currentUser: UserInfo;

  public sizeChoice = 200;
  public sizeOfPages = [
    {
      label: `${this.translater.translate('homeCourrier.sizeOfPages.max')} 200 ${this.translater.translate('homeCourrier.sizeOfPages.show')}`,
      value: 200,
    },
    {
      label: `${this.translater.translate('homeCourrier.sizeOfPages.max')} 500 ${this.translater.translate('homeCourrier.sizeOfPages.show')}`,
      value: 500,
    },
    {
      label: `${this.translater.translate('homeCourrier.sizeOfPages.max')} 1000 ${this.translater.translate('homeCourrier.sizeOfPages.show')}`,
      value: 1000,
    },
    {
      label: `${this.translater.translate('homeCourrier.sizeOfPages.max')} 5000 ${this.translater.translate('homeCourrier.sizeOfPages.show')}`,
      value: 5000,
    },
  ];

  public buttonsIbac = [
    {
      text: this.translater.translate('homeCourrier.buttonsIbac.text'),
      icon: 'bi bi-funnel',
      iconPosition: 'left',
      id: 'mailFoldersCourrierFilterIbac',
      styleClass: 'blue',
      tooltip: this.translater.translate('homeCourrier.buttonsIbac.tooltip'),
    },
  ];
  public bacs: BacSearch[] = [];
  public schedulerColumns: Array<TableColumnsSortableWithSortableLabel> = [];
  public configuration: ConfigDto;
  public globalStatus: GlobalStatus[] = [];

  public tabsArrayNewVisual: { title: string; slug: string; active?: boolean; icon: string }[] = [];
  public openChangeStatutEcheancierModal = false;
  public chosenEcheancierFicheCourrier = null;
  public formChangeStatutEcheancier: UntypedFormGroup = new UntypedFormGroup({
    statutId: new UntypedFormControl(null, Validators.required),
  });

  public creationMailChildrenButton: IButtonMenuItem[] = [
    {
      label: this.translater.translate('modals.internalMail'),
      icon: 'dashboard-icon-intern',
      click: () => {
        this.openCourrierCreate('I');
      },
    },
  ];

  constructor(
    private toastr: ToastrService,
    public router: Router,
    private titleService: Title,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    public params: ParamsService,
    private dialogService: DialogService,
    public confirmService: ConfirmationService,
    public workflows: WorkflowsService,
    private translater: TranslateService,
    private mailsService: MailsService,
    private documentsService: DocumentsService,
    private configService: ConfigService,
    private globalSpecificStatutesService: GlobalSpecificStatutesService,
    private meService: MeService
  ) {
    const source = interval(100000);
    this.subscription = source.subscribe({
      next: () => {
        if (sessionStorage.getItem('boxes_count')) {
          sessionStorage.removeItem('boxes_count');
          this.getMenuAndCount();
        }
      },
    });
  }

  ngOnInit(): void {
    // KANBAN commented
    this.tabsArrayNewVisual = [
      {
        title: this.translater.translate('homeCourrier.tab.dashboard'),
        slug: 'TDB',
        active: true,
        icon: 'bi bi-eye-fill',
      },
      // { title: this.translater.translate('homeCourrier.tab.kanban'), slug: 'Kanban', icon: 'bi bi-kanban' },
      { title: this.translater.translate('homeCourrier.tab.inventory'), slug: 'Inventory', icon: 'bi bi-list-nested' },
    ];
    this.dataService.setSidebarSmall(true);
    sessionStorage.removeItem('filter-type');
    sessionStorage.removeItem('filter-date');
    sessionStorage.removeItem('filter-search');
    this.titleService.setTitle(this.translater.translate('tabsTitle.mails'));
    sessionStorage.removeItem('reloadData');
    sessionStorage.removeItem('searchData');
    if (!sessionStorage.getItem('reloadDashboard')) {
      sessionStorage.setItem('reloadDashboard', '0');
    }
    this.searchFilesParams = null;
    this.courrierScheduler = [];
    if (history.state && history.state.isScan === true) {
      this.isScanMode = true;
    } else {
      this.isScanMode = false;
    }

    async.waterfall([
      (cb) => {
        this.getMyBacs().then(() => {
          cb();
        });
      },
      (cb) => {
        this.getMailsForScheduler().then(() => {
          cb();
        });
      },
      (cb) => {
        this.getConfiguration().then(() => {
          cb();
        });
      },
      (cb) => {
        this.meService.rightMailGlobal().subscribe({
          next: (res: MeRightMailGlobal) => {
            this.rightMailGlobal = res;
            cb(null);
          },
        });
      },
      (cb) => {
        this.meService.getMyPersonalParams('CourrierRechercheSauvegardee').subscribe({
          next: (res: PersonalParams[]) => {
            if (res && res.length > 0) {
              res.map((item) => {
                if (item.hideInDashboard === false) {
                  this.savedSearch.push({
                    id: item.id,
                    name: item.name,
                    menu: 'savedSearch',
                    title: item.description,
                    displayOrder: item.displayOrder,
                    hideFromPersonalDashboard: 'false',
                    click: () => {
                      const data = JSON.parse(item.value);
                      let tag = 'all';
                      if (data && data.Tag) {
                        //Switch sur tous les tags afin d'avoir un switch complet, permettant d'avoir une vraie vue tags et données url liées
                        switch (data.Tag) {
                          case 'All':
                            tag = 'all';
                            break;
                          case 'Entrant':
                            tag = 'entrants';
                            data.Type = 'E';
                            break;
                          case 'Sortant':
                            tag = 'sortants';
                            data.Type = 'S';
                            break;
                          case 'Interne':
                            tag = 'internes';
                            data.Type = 'I';
                            break;
                          case 'NonLus':
                            tag = 'nonLus';
                            break;
                          case 'Lus':
                            tag = 'Lus';
                            break;
                          case 'PourInfo':
                            tag = 'PourInfo';
                            break;
                          case 'APrendreEnCharge':
                            tag = 'aPrendreEnCharge';
                            break;
                          case 'PrisEnCharge':
                            tag = 'prisEnCharge';
                            break;
                          case 'NonPrisEnCharge':
                            tag = 'NonPrisEnCharge';
                            break;
                          case 'AValider':
                            tag = 'AValider';
                            break;
                          case 'ADistribuer':
                            tag = 'ADistribuer';
                            break;
                          case 'ACompleter':
                            tag = 'ACompleter';
                            break;
                          case 'MalRoutes':
                            tag = 'MalRoutes';
                            break;
                          case 'Epingles':
                            tag = 'epingles';
                            break;
                          case 'PourAction':
                            tag = 'pourAction';
                            break;
                          case 'RecemmentConsultes':
                            tag = 'recemmentConsultes';
                            break;
                          case 'RecemmentCrees':
                            tag = 'recemmentCrees';
                            break;
                          case 'AClasser':
                            tag = 'AClasser';
                            break;
                          default:
                            tag = data.Tag;
                        }
                      } else {
                        data.Tag = 'all';
                      }
                      sessionStorage.setItem('reloadData', 'oui');
                      sessionStorage.setItem('advancedSearch', 'oui');
                      sessionStorage.setItem('searchData', JSON.stringify(data));
                      setTimeout(() => {
                        this.router.navigate(['/private/ic/courriers/' + tag]);
                      }, 500);
                    },
                  });
                }
              });
              cb(null);
            } else {
              this.savedSearch = [];
              cb(null);
            }
          },
        });
      },
      (cb) => {
        this.meService.getMyPersonalParams('CourrierFavoris').subscribe({
          next: (res: PersonalParams[]) => {
            this.favorites = res;
            cb(null);
          },
        });
      },
      (cb) => {
        const tempBox: Box[][] = [];
        tempBox.push(
          [],
          [
            {
              name: 'all',
              menu: 'all',
              title: 'Tous les courriers',
              // title: this.translater.translate('homeCourrier.menuBox.all'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-all',
              whiteIcon: 'dashboard-icon-all-white',
              backgroundColor: 'rgba(36, 52, 75,0.2)',
              iconColor: 'rgb(36, 52, 75)',
              click: () => {
                this.router.navigate(['/private/ic/courriers/all']);
                sessionStorage.removeItem('reloadData');
                sessionStorage.setItem('Tag', 'All');
              },
            },

            {
              name: 'entrants',
              menu: 'entrants',
              title: 'Tous les entrants',
              // title: this.translater.translate('homeCourrier.menuBox.entrants'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-entrant',
              whiteIcon: 'dashboard-icon-entrant-white',
              backgroundColor: 'rgba(189, 39, 224,0.2)',
              iconColor: 'rgb(189, 39, 224)',
              click: () => {
                this.router.navigate(['/private/ic/courriers/entrants']);
                sessionStorage.setItem('Tag', 'E');
              },
            },

            {
              name: 'sortants',
              menu: 'sortants',
              title: 'Tous les sortants',
              // title: this.translater.translate('homeCourrier.menuBox.sortants'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-sortant',
              whiteIcon: 'dashboard-icon-sortant-white',
              backgroundColor: 'rgba(80, 226, 193,0.2)',
              iconColor: 'rgb(80, 226, 193)',
              click: () => {
                this.router.navigate(['/private/ic/courriers/sortants']);
                sessionStorage.setItem('Tag', 'S');
              },
            },

            {
              name: 'internes',
              menu: 'internes',
              title: 'Tous les internes',
              // title: this.translater.translate('homeCourrier.menuBox.internes'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-intern',
              whiteIcon: 'dashboard-icon-intern-white',
              backgroundColor: 'rgba(36, 52, 75,0.2)',
              iconColor: 'rgb(80,227,194)',
              click: () => {
                this.router.navigate(['/private/ic/courriers/internes']);
                sessionStorage.setItem('Tag', 'I');
              },
            },

            {
              name: 'nonLus',
              menu: 'nonLus',
              title: 'Non lu(s)',
              // title: this.translater.translate('homeCourrier.menuBox.nonLus'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-non-lus',
              whiteIcon: 'dashboard-icon-non-lus-white',
              backgroundColor: 'rgba(255, 98, 96,0.2)',
              iconColor: 'rgb(255, 98, 96)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/nonLus']);
                sessionStorage.setItem('Tag', 'NonLus');
              },
            },

            {
              name: 'Lus',
              menu: 'Lus',
              title: 'Lu(s)',
              // title: this.translater.translate('homeCourrier.menuBox.lus'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-lu',
              whiteIcon: 'dashboard-icon-lu-white',
              backgroundColor: 'rgba(59, 222, 134,0.2)',
              iconColor: 'rgb(59, 222, 134)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/Lus']);
                sessionStorage.setItem('Tag', 'Lus');
              },
            },

            {
              name: 'PourInfo',
              menu: 'PourInfo',
              title: 'Pour information',
              // title: this.translater.translate('homeCourrier.menuBox.pourInfo'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-pour-info',
              whiteIcon: 'dashboard-icon-pour-info-white',
              backgroundColor: 'rgba(50, 197, 255,0.2)',
              iconColor: 'rgb(50, 197, 255)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/PourInfo']);
                sessionStorage.setItem('Tag', 'PourInfo');
              },
            },

            {
              name: 'aPrendreEnCharge',
              menu: 'aPrendreEnCharge',
              title: 'Prise en charge pour mon service',
              // title: this.translater.translate('homeCourrier.menuBox.aPrendreEnCharge'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-prendre-en-charge',
              whiteIcon: 'dashboard-icon-prendre-en-charge-white',
              backgroundColor: 'rgba(36, 52, 75,0.2)',
              iconColor: 'rgb(36, 52, 75)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/aPrendreEnCharge']);
                sessionStorage.setItem('Tag', 'APrendreEnCharge');
              },
            },

            {
              name: 'prisEnCharge',
              menu: 'prisEnCharge',
              title: 'Prise en charge demandée par mon service',
              // title: this.translater.translate('homeCourrier.menuBox.prisEnCharge'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-demandes-de-prises-en-charge',
              whiteIcon: 'dashboard-icon-demandes-de-prises-en-charge-white',
              backgroundColor: 'rgba(247, 181, 0,0.2)',
              iconColor: 'rgb(247, 181, 0)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/prisEnCharge']);
                sessionStorage.setItem('Tag', 'PrisEnCharge');
              },
            },

            {
              name: 'NonPrisEnCharge',
              menu: 'NonPrisEnCharge',
              title: 'Demandes non prises en charge par mon service',
              // title: this.translater.translate('homeCourrier.menuBox.nonPrisEnCharge'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-demandes-non-prises-en-charge',
              whiteIcon: 'dashboard-icon-demandes-non-prises-en-charge-white',
              backgroundColor: 'rgba(255, 98, 96,0.2)',
              iconColor: 'rgb(255, 98, 96)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/NonPrisEnCharge']);
                sessionStorage.setItem('Tag', 'NonPrisEnCharge');
              },
            },

            {
              name: 'AValider',
              menu: 'AValider',
              title: 'Courriers entrants à valider',
              // title: this.translater.translate('homeCourrier.menuBox.aValider'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-a-valider',
              whiteIcon: 'dashboard-icon-a-valider-white',
              backgroundColor: 'rgba(189, 39, 224,0.2)',
              iconColor: 'rgb(189, 39, 224)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigateByUrl('/private/ic/courriers/AValider');
                sessionStorage.setItem('Tag', 'AValider');
              },
            },

            {
              name: 'ADistribuer',
              menu: 'aDistribuer',
              title: 'A distribuer',
              // title: this.translater.translate('homeCourrier.menuBox.aDistribuer'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-a-distribuer',
              whiteIcon: 'dashboard-icon-a-distribuer-white',
              backgroundColor: 'rgba(255, 184, 71, 0.2)',
              iconColor: 'rgb(255, 184, 71)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/ADistribuer']);
                sessionStorage.setItem('Tag', 'ADistribuer');
              },
            },

            {
              name: 'ACompleter',
              menu: 'aCompleter',
              title: 'A compléter',
              // title: this.translater.translate('homeCourrier.menuBox.aCompleter'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-a-completer',
              whiteIcon: 'dashboard-icon-a-completer-white',
              backgroundColor: 'rgba(36, 52, 75,0.2)',
              iconColor: 'rgb(36, 52, 75)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/ACompleter']);
                sessionStorage.setItem('Tag', 'ACompleter');
              },
            },

            {
              name: 'MalRoutes',
              menu: 'malRoutes',
              title: 'Mal routé(s)',
              // title: this.translater.translate('homeCourrier.menuBox.malRoutes'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-mal-routes',
              whiteIcon: 'dashboard-icon-mal-routes-white',
              backgroundColor: 'rgba(189, 39, 224,0.2)',
              iconColor: 'rgb(189, 39, 224)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/MalRoutes']);
                sessionStorage.setItem('Tag', 'MalRoutes');
              },
            },

            {
              name: 'epingles',
              menu: 'epingles',
              title: 'Epinglé(s)',
              // title: this.translater.translate('homeCourrier.menuBox.epingles'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-epingles',
              whiteIcon: 'dashboard-icon-epingles-white',
              backgroundColor: 'rgba(247, 181, 0, 0.2)',
              iconColor: 'rgb(247, 181, 0)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/epingles']);
                sessionStorage.setItem('Tag', 'Epingles');
              },
            },

            {
              name: 'pourAction',
              menu: 'pourAction',
              title: 'Pour action',
              // title: this.translater.translate('homeCourrier.menuBox.pourAction'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-pour-action',
              whiteIcon: 'dashboard-icon-pour-action-white',
              backgroundColor: 'rgba(96, 205, 255, 0.2)',
              iconColor: 'rgb(96, 205, 255)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/pourAction']);
                sessionStorage.setItem('Tag', 'PourAction');
              },
            },

            {
              name: 'recemmentConsultes',
              menu: 'recemmentConsultes',
              title: 'Récemment consulté(s)',
              // title: this.translater.translate('homeCourrier.menuBox.recemmentConsultes'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-recemment-consultes',
              whiteIcon: 'dashboard-icon-recemment-consultes-white',
              backgroundColor: 'rgba(80, 226, 193, 0.2)',
              iconColor: 'rgb(80, 226, 193)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/recemmentConsultes']);
              },
            },

            {
              name: 'recemmentCrees',
              menu: 'recemmentCrees',
              title: 'Récemment créé(s)',
              // title: this.translater.translate('homeCourrier.menuBox.recemmentCrees'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-recemment-crees',
              whiteIcon: 'dashboard-icon-recemment-crees-white',
              backgroundColor: 'rgba(96, 205, 255, 0.2)',
              iconColor: 'rgb(96, 205, 255)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/recemmentCrees']);
              },
            },

            {
              name: 'aClasser',
              menu: 'aClasser',
              title: 'Courrier à classer',
              // title: this.translater.translate('homeCourrier.menuBox.aClasser'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-a-classer',
              whiteIcon: 'dashboard-icon-a-classer-white',
              backgroundColor: 'rgba(255, 184, 71, 0.2)',
              iconColor: 'rgb(255, 184, 71)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                sessionStorage.removeItem('searchData');
                this.router.navigate(['/private/ic/courriers/AClasser']);
              },
            },

            {
              name: 'echeancier',
              menu: 'echeancier',
              title: 'Échéancier',
              // title: this.translater.translate('homeCourrier.menuBox.echeancier'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-echeancier',
              whiteIcon: 'dashboard-icon-echeancier-white',
              backgroundColor: 'rgba(36, 52, 75,0.2)',
              iconColor: 'rgb(36, 52, 75)',
              click: () => {
                this.mode = 'TDB';
                this.isScanMode = false;
              },
            },

            {
              name: 'ibac',
              menu: 'ibac',
              title: 'Bacs',
              // title: this.translater.translate('homeCourrier.menuBox.ibac'),
              hideFromPersonalDashboard: 'false',
              icon: 'dashboard-icon-bacs',
              whiteIcon: 'dashboard-icon-bacs-white',
              backgroundColor: 'rgba(96, 205, 255, 0.2)',
              iconColor: 'rgb(96, 205, 255)',
              click: () => {
                sessionStorage.removeItem('reloadData');
                this.mode = 'iBac';
                this.isScanMode = false;
              },
            },
          ],
          []
        );
        this.boxes2.push([], [], []);
        if (this.favorites.length > 0) {
          tempBox[0] = JSON.parse(_.first(this.favorites).value);
          //on va reset les icônes avec les bonnes parce que ce qui ets renvoyé du back ne contient possiblement pas les bonnes icônes!
          tempBox[0].map((fav) => {
            const index = tempBox[1].map((x) => x.name).indexOf(fav.name);
            if (index > -1) {
              fav.icon = tempBox[1][index].icon;
              fav.whiteIcon = tempBox[1][index].whiteIcon;
              fav.backgroundColor = tempBox[1][index].backgroundColor;
              fav.iconColor = tempBox[1][index].iconColor;
              fav.hideFromPersonalDashboard = tempBox[1][index].hideFromPersonalDashboard;
            }
          });
        }
        if (tempBox[0].length > 0) {
          tempBox[0].map((box) => {
            if (box.menu === 'aCompleter') {
              box.hide = this.rightMailGlobal.menu['aCompleter'] === false ? true : false;
            } else if (box.menu === 'aCreer') {
              box.hide = this.rightMailGlobal.menu['aCreer'] === false ? true : false;
            } else if (box.menu === 'aDistribuer') {
              box.hide = this.rightMailGlobal.menu['aDistribuer'] === false ? true : false;
            } else if (box.menu === 'malRoutes') {
              box.hide = this.rightMailGlobal.menu['malRoutes'] === false ? true : false;
            } else if (box.menu === 'prisEnCharge' || box.menu === 'aPrendreEnCharge' || box.menu === 'NonPrisEnCharge') {
              if (
                this.rightMailGlobal.menu['priseEnCharge'] === false ||
                this.configuration.priseEnChargeCourriers?.fermerMasquerPriseEnCharge === true
              ) {
                box.hide = true;
              } else {
                box.hide = false;
              }
            } else if (box.menu === 'AValider') {
              box.hide = this.rightMailGlobal.menu['validation'] === false ? true : false;
            } else if (box.menu === 'aClasser') {
              box.hide = this.rightMailGlobal.menu['aClasser'] === false ? true : false;
            } else {
              box.hide = false;
            }
          });
        }
        if (tempBox[1].length > 0) {
          tempBox[1].map((box) => {
            if (box.menu === 'aCompleter') {
              box.hide = this.rightMailGlobal.menu['aCompleter'] === false ? true : false;
            } else if (box.menu === 'aCreer') {
              box.hide = this.rightMailGlobal.menu['aCreer'] === false ? true : false;
            } else if (box.menu === 'aDistribuer') {
              box.hide = this.rightMailGlobal.menu['aDistribuer'] === false ? true : false;
            } else if (box.menu === 'malRoutes') {
              box.hide = this.rightMailGlobal.menu['malRoutes'] === false ? true : false;
            } else if (box.menu === 'prisEnCharge' || box.menu === 'aPrendreEnCharge' || box.menu === 'NonPrisEnCharge') {
              if (
                this.rightMailGlobal.menu['priseEnCharge'] === false ||
                this.configuration.priseEnChargeCourriers?.fermerMasquerPriseEnCharge === true
              ) {
                box.hide = true;
              } else {
                box.hide = false;
              }
            } else if (box.menu === 'AValider') {
              box.hide = this.rightMailGlobal.menu['validation'] === false ? true : false;
            } else if (box.menu === 'aClasser') {
              box.hide = this.rightMailGlobal.menu['aClasser'] === false ? true : false;
            } else {
              box.hide = false;
            }
          });
        }

        if (tempBox[0].length > 0 && tempBox[1].length > 0) {
          tempBox[0].map((first) => {
            first.click = () => {
              if (first.name === 'aCreer') {
                sessionStorage.removeItem('reloadData');
                this.isScanMode = true;
              } else if (first.name === 'echeancier') {
                this.mode = 'TDB';
                this.isScanMode = false;
              } else if (first.name === 'ibac') {
                this.mode = 'iBac';
                this.isScanMode = false;
              } else {
                this.router.navigate(['/private/ic/courriers/' + first.name]);
                sessionStorage.setItem('Tag', first.name);
              }
            };
            tempBox[1].map((second) => {
              if (first.name === second.name) {
                second.hide = true;
              }
            });
          });
        }
        if (this.savedSearch.length > 0) {
          this.boxes2[2] = _.sortBy(this.savedSearch, 'displayOrder');
        } else {
          this.boxes2[2] = [];
        }
        this.boxes2[0] = tempBox[0].filter((x) => x.hide === false);
        this.boxes2[1] = tempBox[1].filter((x) => x.hide === false);
        cb(null);
      },
      (cb) => {
        if (!sessionStorage.getItem('boxes_count')) {
          this.getMenuAndCount();
        } else {
          const boxes = JSON.parse(sessionStorage.getItem('boxes_count'));

          if (boxes[0].length > 0 && this.boxes2[1].length > 0) {
            this.boxes2[1].map((box2) => {
              boxes[0].map((box) => {
                box.click = () => {
                  if (box.name === 'aCreer') {
                    sessionStorage.removeItem('reloadData');
                    this.isScanMode = true;
                  } else if (box.name === 'echeancier') {
                    this.mode = 'TDB';
                    this.isScanMode = false;
                  } else if (box.name === 'ibac') {
                    this.mode = 'iBac';
                    this.isScanMode = false;
                  } else {
                    this.router.navigate(['/private/ic/courriers/' + box.name]);
                    sessionStorage.setItem('Tag', box.name);
                  }
                };
                if (box2.name === box.name) {
                  box2.count = box.count;
                }
              });
            });
          }
          if (boxes[0].length > 0 && this.boxes2[0].length > 0) {
            this.boxes2[0].map((box2) => {
              boxes[0].map((box) => {
                if (box.name === box2.name) {
                  box2.count = box.count;
                }
              });
            });
          }
        }
        cb(null);
      },
    ]);
    const classement = localStorage.getItem('classement');
    if (classement) {
      this.mode = 'Inventory';
      // KANBAN commented
      this.tabsArrayNewVisual[0].active = false;
      this.tabsArrayNewVisual[1].active = true;
      // this.tabsArrayNewVisual[0].active = false;
      // this.tabsArrayNewVisual[1].active = false;
      // this.tabsArrayNewVisual[2].active = true;
    }
  }

  openList(): void {
    this.router.navigateByUrl('/private/ic/actions');
  }

  onMailSelect(event): void {
    if (event && event.id) {
      const url = '/private/ic/tabs/';
      const config = environment;
      window.open(config.baseUrl + url + event.id);
    }
  }

  getMenuAndCount(): void {
    async.parallel([
      (callback) => {
        this.getMailsCount('NonLus,APrendreEnCharge,ADistribuer,Epingles,MalRoutes,PourInfo,PrisEnCharge,NonPrisEnCharge', 'seq2');
        callback(null);
      },
      (callback) => {
        this.getMailsCount('PourAction,AValider,ACompleter,ADistribuer,AClasser', 'seq3');
        callback(null);
      },
    ]);
  }

  getMailsCount(args: string, sequence: string): void {
    this.mailsService.getMailsCount(args).subscribe({
      next: (response) => {
        this.temp1.push({ name: 'all', count: null });
        if (sequence === 'seq2') {
          this.countsSeq2 = response;
          if (this.countsSeq2) {
            this.temp2.push(
              { name: 'entrants', count: this.countsSeq2.entrants },
              { name: 'sortants', count: this.countsSeq2.sortants },
              { name: 'internes', count: this.countsSeq2.internes },
              { name: 'nonLus', count: this.countsSeq2.nonLus },
              { name: 'PourInfo', count: this.countsSeq2.pourInfo },
              { name: 'Lus', count: this.countsSeq2.lus },
              { name: 'MalRoutes', count: this.countsSeq2.malRoutes },
              { name: 'aPrendreEnCharge', count: this.countsSeq2.aPrendreEnCharge },
              { name: 'NonPrisEnCharge', count: this.countsSeq2.nonPrisEnCharge },
              { name: 'epingles', count: this.countsSeq2.epingles },
              { name: 'prisEnCharge', count: this.countsSeq2.prisEnCharge }
            );
          }
        }
        if (sequence === 'seq3') {
          this.countsSeq3 = response;
          if (this.countsSeq3) {
            this.temp3.push(
              { name: 'AValider', count: this.countsSeq3.aValider },
              { name: 'pourAction', count: this.countsSeq3.pourAction },
              { name: 'entrantsAValider', count: this.countsSeq3.entrantsAValider },
              { name: 'sortantsAValider', count: this.countsSeq3.sortantsAValider },
              { name: 'recemmentConsultes', count: this.countsSeq3.recemmentConsultes },
              { name: 'recemmentCrees', count: this.countsSeq3.recemmentCrees },
              { name: 'ACompleter', count: this.countsSeq3.aCompleter },
              { name: 'ADistribuer', count: this.countsSeq3.aDistribuer },
              {
                name: 'aClasser',
                title: this.translater.translate('mail.toFile'),
                icon: 'bi bi-text-paragraph',
                count: this.countsSeq3.aClasser,
              },
              {
                name: 'echeancier',
                title: this.translater.translate('mail.schedule'),
                count: this.courrierScheduler?.length ? this.courrierScheduler.length : null,
              }
            );
          }
        }
        if (this.temp2.length > 0 && this.temp3.length > 0) {
          this.boxes = [];
          this.boxes = [this.temp1.concat(this.temp2, this.temp3)];

          if (this.boxes2[0].length > 0) {
            this.boxes2[0].map((box2) => {
              this.boxes[0].map((box) => {
                if (box2.name === box.name) {
                  box2.count = box.count;
                }
              });
            });
          }
          if (this.boxes2[1].length > 0) {
            this.boxes2[1].map((box2) => {
              this.boxes[0].map((box) => {
                if (box2.name === box.name) {
                  box2.count = box.count;
                }
              });
            });
          }

          this.boxes3 = this.boxes2;
          sessionStorage.setItem('boxes_count', JSON.stringify(this.boxes));
        }
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }
  /**
   * Method retreive all mails with a echeance date ( 01/01/2020 => today )
   * Load status calue with color
   * delete item from array if status === 'abadonné' and 'Archivé'
   */
  getMailsForScheduler(): Promise<boolean> {
    return new Promise((resolve) => {
      forkJoin({
        documentsStatus: this.documentsService.fetchDocumentsStatutes().pipe(
          catchError(() => {
            this.toastr.error(this.translater.translate('status.loadingIsImpossible'));
            return of(null);
          })
        ),
        globalStatus: this.globalSpecificStatutesService.getGlobalStatus().pipe(
          catchError(() => {
            this.toastr.error(this.translater.translate('status.loadingIsImpossible'));
            return of(null);
          })
        ),
        userInfos: this.meService.getUserInfo().pipe(
          catchError(() => {
            this.toastr.error(this.translater.translate('status.loadingIsImpossible'));
            return of(null);
          })
        ),
      }).subscribe((value) => {
        this.formatDocumentsStatus(value.documentsStatus);
        this.formatGlobalStatus(value.globalStatus);
        this.setMailButtons(value.userInfos);
        this.fetchSchedulerMails(undefined).then(() => {
          this.schedulerColumns = [
            {
              field: 'objet',
              filterableSortableLabel: 'objetFormatedLabel',
              header: this.translater.translate('object'),
            },
            {
              field: 'typeEntrantSortant',
              filterableSortableLabel: 'typeEntrantSortantLabel',
              header: this.translater.translate('type'),
            },
            {
              field: 'statutId',
              filterableSortableLabel: 'statutIdLabel',
              header: this.translater.translate('status.title'),
            },
            {
              field: 'dateEcheance',
              filterableSortableLabel: 'dateEcheanceLabel',
              header: this.translater.translate('dueDate'),
            },
            {
              field: 'serviceProprietaire',
              filterableSortableLabel: 'serviceProprietaireLabel',
              header: this.translater.translate('ownerService'),
            },
          ];
          resolve(true);
        });
      });
    });
  }

  private formatDocumentsStatus(documentsStatus: DocumentStatusDto[]): void {
    this.schedulerStatusList = [];
    documentsStatus.forEach((item) => {
      if (!item.notUsed) {
        this.schedulerStatusList.push({
          label: item.description,
          value: item.id,
          color: item.color,
          textColor: this.getOppositeColor(item.color),
          statut: item,
          ordre: item.ordreAffichage,
          globalStatutId: item.globalStatutId,
        });
      }
    });
  }

  private formatGlobalStatus(globalStatus: GlobalStatusDTO[]): void {
    this.globalStatus = globalStatus;

    this.schedulerStatusList.map((item) => {
      const globalStatusFound = globalStatus.find((x) => x.id === item?.globalStatutId);
      item.globalStatutName = globalStatusFound ? globalStatusFound?.description : null;
    });
  }

  private setMailButtons(userInfos: UserInfo): void {
    this.currentUser = userInfos;
    if (userInfos.encodageNouveauEntrant) {
      this.creationMailChildrenButton.push({
        label: this.translater.translate('modals.incomingMail'),
        icon: 'dashboard-icon-entrant',
        click: () => {
          this.openCourrierCreate('E');
        },
      });
    }
    if (userInfos.encodageNouveauSortant) {
      this.creationMailChildrenButton.push({
        label: this.translater.translate('modals.outgoingMail'),
        icon: 'dashboard-icon-sortant',
        click: () => {
          this.openCourrierCreate('S');
        },
      });
    }
  }

  private fetchSchedulerMails(pageSize?: number): Promise<boolean> {
    return new Promise((resolve) => {
      this.spinner.show();
      this.mailsService
        .getAllMails({
          DtEcheanceMin: '01/01/2020',
          SvcPropIds: this.currentUser.services,
          Tag: 'Echeancier',
          PageSize: pageSize ?? 200,
          CalcTotal: false,
        })

        .pipe(
          map((res) => {
            if (!res.items.length || !res) return of([]);

            return res.items.map((mail: MailMeSearchDto) => {
              const formattedMail: MailMeSearchDto & {
                objetFormated: string;
                statutIdLabel: string;
                statutDatas: {
                  label: string;
                  value: number;
                  color: string;
                  textColor: string;
                  statut: DocumentStatusDto;
                  ordre: number;
                  globalStatutId: number;
                  globalStatutName?: string;
                };
              } = {
                ...mail,
                objetFormated: mail.objet.length > 40 ? mail.objet.slice(0, 40) + ' ...' : mail.objet,
                statutDatas: this.schedulerStatusList.find((el) => el.value === mail.statutId),
                statutIdLabel: this.schedulerStatusList.find((x) => x.value === mail.statutId)?.label,
              };
              return formattedMail;
            });
          })
        )
        .subscribe({
          next: (
            res: (MailMeSearchDto & {
              objetFormated: string;
              statutIdLabel: string;
              statutDatas: {
                label: string;
                value: number;
                color: string;
                textColor: string;
                statut: DocumentStatusDto;
                ordre: number;
                globalStatutId: number;
                globalStatutName?: string;
              };
            })[]
          ) => {
            if (res?.length > 0) {
              this.courrierScheduler = res
                .filter((mail) => mail?.statutDatas?.globalStatutName !== 'Terminé')
                .map((mail) => new CourrierScheduler(mail));
            } else {
              this.courrierScheduler = [];
            }

            this.spinner.hide();
            resolve(true);
          },
          error: (err: HttpErrorResponse) => {
            console.error(err);
            this.spinner.hide();
          },
        });
    });
  }

  public onChangeNewVisual(event) {
    this.isScanMode = false;
    this.mode = event.value.slug;

    // Waiting for anyone to notice ( // KANBAN commented as asked)
    // if (this.mode === 'Kanban') {
    //   this.displayKanban = true;
    //   this.getAllMails({ CalcTotal: false });
    // }
  }

  // Waiting for anyone to notice ( // KANBAN commented)
  // getAllMails(params?: MailsMeSearchParams): void {
  //   this.spinner.show();
  //   this.mailsService.getAllMails(params).subscribe({
  //     next: (res: MailMeSearchPaginationDTO) => {
  //       this.items = _.uniq(res.items, 'id');
  //       this.items.items.map((item) => {
  //         item.serviceProprietaire.description = setServiceDescription(item.serviceProprietaire);
  //         return item;
  //       });
  //       console.log(this.items);
  //       this.spinner.hide();
  //     },
  //     error: (error) => {
  //       console.error(error);
  //       this.spinner.hide();
  //     },
  //   });
  //   this.globalSpecificStatutesService.getGlobalStatus().subscribe({
  //     next: (res: GlobalStatusDTO[]) => {
  //       this.columns = res;
  //     },
  //   });
  // }

  public checkOpenMailRights(event): void {
    if (this.creationMailChildrenButton.length > 1) {
      event.stopPropagation();
      event.preventDefault();
    } else {
      this.creationMailChildrenButton[0].click();
    }
  }

  openCourrierCreate(mailType: string): void {
    const data: MailInfosViaExtraStateRouter = {
      mailType: mailType,
      mailMode: 'edit',
      isNew: true,
      isAnswerMode: false,
    };
    this.router.navigate(['/private/ic/new'], { state: data });
  }

  receive_params(params: { classeurId?: number; chemiseId?: number }): void {
    this.searchFilesParams = null;
    this.searchFilesParams = params;
  }

  redirectToCourrierFich(mailId): void {
    this.router.navigate(['/private/ic/tabs/' + mailId]);
  }

  /**
   * Retreive all courrier statues
   * Used for scheduler
   */
  getCourrierStatus(): void {
    this.documentsService.fetchDocumentsStatutes().subscribe({
      next: (res: DocumentStatusDto[]) => {
        this.schedulerStatusList = [];
        res.map((item) => {
          if (item.notUsed === false) {
            this.schedulerStatusList.push({
              label: item.description,
              value: item.id,
              color: item.color,
              textColor: this.getOppositeColor(item.color),
              statut: item,
              ordre: item.ordreAffichage,
              globalStatutId: item.globalStatutId,
            });
          }
        });
        this.globalSpecificStatutesService.getGlobalStatus().subscribe({
          next: (res: GlobalStatusDTO[]) => {
            this.columns = res;
          },
        });
      },
      error: (error) => {
        console.error('Error : ', error);
        this.toastr.error(this.translater.translate('status.impossible'));
      },
    });
  }

  changeGlobalStatus(): void {
    if (this.formChangeStatutEcheancier.valid) {
      this.mailsService.patchMailStatus(this.chosenEcheancierFicheCourrier.id, this.formChangeStatutEcheancier.value.statutId).subscribe({
        next: () => {
          this.toastr.success(this.translater.translate('status.updated'));
          this.chosenEcheancierFicheCourrier = null;
          this.openChangeStatutEcheancierModal = false;
          this.ngOnInit();
        },
        error: (error) => {
          console.error('Error : ', error);
          this.toastr.error(this.translater.translate('status.impossible'));
        },
      });
    } else {
      this.toastr.error(this.translater.translate('pleaseFulfillRequiredFields'));
    }
  }

  getOppositeColor(bgColor): string {
    if (bgColor) {
      const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      const r = parseInt(color.substring(0, 2), 16); // hexToR
      const g = parseInt(color.substring(2, 4), 16); // hexToG
      const b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
  }

  getMyBacs(): Promise<boolean> {
    return new Promise((resolve) => {
      this.workflows.getBacsSearch().subscribe({
        next: (res: BacSearch[]) => {
          res = res.map((x) => {
            return new BacSearch(x);
          });
          this.bacs = res;
          resolve(true);
        },
        error: (error) => {
          console.error(error);
          this.toastr.error(this.translater.translate('error.errorOccurredWhileRetrievingBacsSearch'));
        },
      });
    });
  }

  loadBac(bac): void {
    this.router.navigate(['/private/ic/courriers/bacs/']);
    localStorage.setItem('bacsIds', bac.bac.id);
  }

  pageSizeChange() {
    this.fetchSchedulerMails(this.sizeChoice);
  }

  getConfiguration(): Promise<boolean> {
    return new Promise((resolve) => {
      this.configService.fetchConfig().subscribe({
        next: (res) => {
          this.configuration = res;
          if (this.configuration.mails.hideClassementDossiers === true) {
            this.tabsArrayNewVisual.pop();
          }
          if (res.connecteurs.isExchangeConfigured) {
            this.creationMailChildrenButton.push({
              label: this.translater.translate('modals.email'),
              icon: 'bi bi-mailbox',
              click: () => {
                this.router.navigateByUrl('/private/ic/courriers-exchange');
              },
            });
          }
          resolve(true);
        },
        error: (error) => {
          console.error(error);
          this.toastr.error(this.translater.translate('error.errorOccurredWhileRetrievingConfiguration'));
        },
      });
    });
  }

  openChangeStatutEcheancier(rowData): void {
    this.chosenEcheancierFicheCourrier = rowData;
    this.formChangeStatutEcheancier.patchValue({
      statutId: rowData.statutId ? rowData.statutId : null,
    });
    this.openChangeStatutEcheancierModal = true;
  }

  closeModalChangeStatutEcheancierModal(): void {
    this.chosenEcheancierFicheCourrier = null;
    this.openChangeStatutEcheancierModal = false;
  }
}
